import { render, staticRenderFns } from "./HeritageNodeSelector.vue?vue&type=template&id=04e163d7&scoped=true"
import script from "./HeritageNodeSelector.vue?vue&type=script&lang=ts"
export * from "./HeritageNodeSelector.vue?vue&type=script&lang=ts"
import style0 from "./HeritageNodeSelector.vue?vue&type=style&index=0&id=04e163d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e163d7",
  null
  
)

export default component.exports